import React from 'react';
import ReactDOM from 'react-dom';
import './includes/custom/css/index.css';
import './includes/custom/css/form.css';
import Routes from './routes';
import { Provider } from 'react-redux';
import configureStore from './store/store';
import { library } from '../node_modules/@fortawesome/fontawesome-svg-core';
import { 
    faCaretRight,
    faCaretLeft, 
    faCaretDown, 
    faFilePdf, 
    faCalendarAlt as solidCalendar,
    faTrashAlt,
    faBook,
    faPlusCircle,
    faCog,
    faEnvelope,
    faAngleLeft,
    faShoppingCart,
    faUserCircle
} from "@fortawesome/free-solid-svg-icons";
import { 
    faCalendarAlt as regularCalendar,
    faEdit,
    faCopy,
    faPlusSquare,
    faMinusSquare
} from "@fortawesome/free-regular-svg-icons";

library.add(
    faCaretRight, 
    faCaretDown, 
    faFilePdf, 
    solidCalendar, 
    regularCalendar, 
    faEdit, 
    faCopy,
    faTrashAlt,
    faBook,
    faPlusCircle,
    faPlusSquare,
    faMinusSquare,
    faCog,
    faEnvelope,
    faCaretLeft,
    faAngleLeft,
    faShoppingCart,
    faUserCircle
);



const Root = () => {
    return(
        <Provider store = {configureStore()}>
            <Routes/>
        </Provider>
    )
}

ReactDOM.render(
    <Root/>,
    document.getElementById('root')
);